import React from 'react';
import {WaypointDispatcher} from '../../../hooks/useWaypoints';
import {formatCoordinates} from '../../../utils/formatters';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import theme from '../../../theme';
import trackAnalytics from '../../../utils/gaia/trackAnalytics';
import WaypointStats from '../WaypointStats';
import fetchGeocode from '../../../utils/gaia/fetchGeocode';

interface WaypointSnackbarProps {
    onInteractionChange: (interaction: MapInteraction) => void;
    interaction: MovingWaypointMapInteraction;
    waypoints: {[pointLocalId: string]: Waypoint};
    waypointDispatcher: WaypointDispatcher;
    map: mapboxgl.Map;
    onPopupChange: (popup: MapPopup) => void;
}

export default function WaypointSnackbar({
    onInteractionChange,
    interaction,
    waypointDispatcher,
    waypoints,
    onPopupChange,
}: WaypointSnackbarProps) {
    const mapboxLayerId = interaction.mapboxLayerId;

    return <Snackbar
        style={{
            marginBottom: theme.spacing(3),
            left: '50%',
            right: 'auto',
            transform: 'translateX(-50%)',
            position: 'absolute',
        }}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        open={interaction.type === 'movingWaypoint'}
        message={interaction.type === 'movingWaypoint' && interaction.pointLocalId && <>
            <span style={{fontSize: 14}}>Drag waypoint</span>
            <WaypointStats
                waypoint={waypoints[interaction.pointLocalId]}
                interaction={interaction}
            />
        </>}
        action={<>
            <Button
                color="secondary"
                onClick={onCancelClick}
                variant="outlined"
                style={{
                    fontSize: 14,
                    marginRight: theme.spacing(1),
                    color: theme.palette.secondary.main,
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1),
                }}
            >
                Cancel
            </Button>
            <Button
                color="primary"
                onClick={onDoneClick}
                variant="contained"
                style={{
                    fontSize: 14,
                    color: '#fff',
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1),
                    marginRight: theme.spacing(1),
                }}
            >
                Save
            </Button>
        </>}
    />;

    async function onDoneClick() {
        if (interaction.type !== 'movingWaypoint') return;
        trackAnalytics('Save Waypoint', {category: 'map2'});
        onInteractionChange({type: 'normal', subtype: 'normal'});

        waypointDispatcher({
            type: 'updateProperties',
            properties: {
                pointLocalId: interaction.pointLocalId,
                ...!interaction.initialWaypoint && {
                    title: 'Loading...'
                }
            },
            save: true,
        });

        onPopupChange({
            type: 'point',
            pointLocalId: interaction.pointLocalId,
            mapboxLayerId,
        });
        const currentPosition = waypoints[interaction.pointLocalId].geometry.coordinates;
        let name = null;

        try {
            name = await fetchGeocode.reverse([currentPosition[0], currentPosition[1]]);
        } catch (err) {
            console.error(err);
        }

        waypointDispatcher({
            type: 'updateProperties',
            properties: {
                pointLocalId: interaction.pointLocalId,
                ...!interaction.initialWaypoint && {
                    title: name || formatCoordinates(currentPosition),
                    isTitleLoaded: true
                }
            },
            save: true,
        });
    }

    function onCancelClick() {
        if (interaction.type !== 'movingWaypoint') return;
        trackAnalytics('Cancel Waypoint Edit', {category: 'map2'});
        onInteractionChange({type: 'normal', subtype: 'normal'});
        if (interaction.initialWaypoint) {
            waypointDispatcher({
                type: 'update',
                waypoint: interaction.initialWaypoint,
                save: false,
            });
            onPopupChange({
                type: 'point',
                pointLocalId: interaction.pointLocalId,
                mapboxLayerId,
            });
        } else {
            waypointDispatcher({
                type: 'remove',
                waypoint: waypoints[interaction.pointLocalId],
            });
        }
    }
}
